module.exports = __webpack_public_path__ + "img/deshadow-before.c2b9aa76.webp";